import { Component, Input } from '@angular/core';
@Component({
    selector: 'seds-header-logo',
    templateUrl: './seds-header-logo.component.html',
    styleUrls: ['./seds-header-logo.component.scss'],
    standalone: false
})
export class SedsHeaderLogoComponent {
  @Input() applicationName?: string;
  @Input() logoImage?: string;
  @Input() smallLogoImage?: string;
  @Input() url?: string;
}
